import type { Component } from '../router';
import { t } from '../i18n/locale';

function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

// PrivacyPage — the public privacy & cookies notice (the interim public half
// of #46; the compliance/retention detail follows in M7). Static trilingual
// copy from the message catalog. Until the admin DSR tooling exists, the
// contact form is the channel for data-subject requests, so the requests
// section ends in a CTA that routes there.
export class PrivacyPage implements Component {
  private root: HTMLElement | null = null;

  mount(host: HTMLElement): void {
    const section = el('section', 'privacy');
    const card = el('article', 'privacy__card');

    const header = el('header', 'privacy__header');
    header.append(
      el('h1', 'privacy__title', t('privacy.title')),
      el('p', 'privacy__updated', t('privacy.updated')),
    );

    card.append(
      header,
      el('p', 'privacy__interim', t('privacy.interim')),
      el('p', 'privacy__intro', t('privacy.intro')),
    );

    const blocks: ReadonlyArray<readonly [string, string]> = [
      [t('privacy.who.title'), t('privacy.who.body')],
      [t('privacy.collect.title'), t('privacy.collect.body')],
      [t('privacy.use.title'), t('privacy.use.body')],
      [t('privacy.store.title'), t('privacy.store.body')],
      [t('privacy.retain.title'), t('privacy.retain.body')],
      [t('privacy.rights.title'), t('privacy.rights.body')],
      [t('privacy.cookies.title'), t('privacy.cookies.body')],
    ];
    for (const [title, body] of blocks) {
      const block = el('section', 'privacy__section');
      block.append(
        el('h2', 'privacy__section-title', title),
        el('p', 'privacy__body', body),
      );
      card.appendChild(block);
    }

    const requests = el('section', 'privacy__section');
    requests.append(
      el('h2', 'privacy__section-title', t('privacy.requests.title')),
      el('p', 'privacy__body', t('privacy.requests.body')),
    );
    const cta = el('a', 'privacy__cta', t('privacy.requests.cta'));
    cta.href = '/contact';
    requests.appendChild(cta);
    card.appendChild(requests);

    section.appendChild(card);
    host.appendChild(section);
    this.root = section;
  }

  unmount(): void {
    this.root?.remove();
    this.root = null;
  }
}
